import {createSelector} from "reselect";

import type {DocumentSelector, DocumentStoreState} from "../types";
import {emptyArray} from "../utils";

const emptySet: Set<string> = new Set();

/**
 * Base selectors for selection state - direct state reads
 * These selectors perform simple property access without complex computation
 */

/** Gets all selected object UIDs */
export const allUids: DocumentSelector<string[]> = (state: DocumentStoreState) =>
    state.selectedObjectUids ?? emptyArray;

/**
 * Gets selected object UIDs as a Set for O(1) lookups.
 * Memoized via reselect — the Set is only recreated when the underlying array reference changes.
 */
export const allUidsSet: DocumentSelector<Set<string>> = createSelector(
    [(state: DocumentStoreState) => state.selectedObjectUids],
    (selectedUids): Set<string> => (selectedUids ? new Set(selectedUids) : emptySet),
);

/** Checks if any object is selected */
export const hasSelection: DocumentSelector<boolean> = (state: DocumentStoreState) =>
    (state.selectedObjectUids?.length ?? 0) > 0;

/** Gets count of selected objects */
export const count: DocumentSelector<number> = (state: DocumentStoreState) => state.selectedObjectUids?.length ?? 0;
